'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureFacebookPixel;

var _scriptLoader = require('./script-loader.js');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureFacebookPixel(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (!config.preloaded) {
    var src = 'https://connect.facebook.net/en_US/fbevents.js';
    var stub = function stub() {
      stub.callMethod ? stub.callMethod.apply(stub, arguments) : stub.queue.push(arguments);
    };
    stub.push = stub;
    stub.loaded = !0;
    stub.version = '2.0';
    stub.queue = [];

    promise = (0, _scriptLoader2.default)({ src: src, globalNames: ['fbq', '_fbq'], stub: stub, window: window, document: document });

    window.fbq('init', config.id);
  }

  handlers.push(handleEvent);

  return promise;
}

function handleEvent(_ref2) {
  var type = _ref2.type,
      id = _ref2.id,
      properties = _ref2.properties;

  if (type === 'page') {
    return window.fbq('track', 'PageView');
  }

  if (type === 'track') {
    return window.fbq('trackCustom', id, properties);
  }

  // TODO: Facebook Pixel does not yet support Setting the
  // UserId like Facebook SDK does.

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/facebook-pixel.js
// module id = 5
// module chunks = 0